import { Tooltip } from '@heroui/react';
import React from 'react';
import { FiInfo } from 'react-icons/fi';

interface InfoTooltipProps {
  header?: string;
  content: React.ComponentType;
}

export const InfoTooltip: React.FC<InfoTooltipProps> = ({
  header,
  content: ContentComponent,
}) => {
  return (
    <Tooltip
      placement="right"
      content={
        <div className="p-3 max-w-xs">
          {header && (
            <h4 className="text-sm font-medium text-foreground mb-2">
              {header}
            </h4>
          )}
          <div className="text-xs text-foreground space-y-2">
            <ContentComponent />
          </div>
        </div>
      }
      classNames={{
        base: 'max-w-xs',
        content: 'bg-content1 border border-default-200',
      }}
    >
      <button
        type="button"
        className="ml-2 text-default-500 hover:text-default-700 transition-colors"
        aria-label={header ? `Info about ${header}` : 'More information'}
      >
        <FiInfo size={16} />
      </button>
    </Tooltip>
  );
};
